import Vue from "vue";
import VueRouter from "vue-router";

import Dashboard from "./components/Dashboard";
import Map from "./components/Map";
import ExplorerMap from "./components/ExplorerMap";
import CompartirMapa from "./components/CompartirMapa";
import ExplorerMapUser from "./components/ExplorerMapUser";
import ExplorerProjectMapUser from "./components/ExplorerProjectMapUser";
import FormList from "./components/FormList";
import FormBuilder from "./components/FormBuilder";
import FormEditBuilder from "./components/FormEditBuilder";
import FormAnswers from "./components/FormAnswers";
import UserList from "./components/UserList";
import GuestUserList from "./components/GuestUserList";
import MonitorsList from "./components/MonitorsList";
import PlacesList from "./components/PlacesList";
import Login from "./components/Login.vue";
import EventsList from "./components/EventsList";
import ComplaintsList from "./components/ComplaintsList";
import Reports from "./components/Reports";
import Config from "./components/Config";
import PasswordChange from "./components/PasswordChange";
import Privacy from "./components/Privacy";
import Support from "./components/Support";
import AlertList from "./components/AlertList";
import RaisingList from "./components/RaisingList";
import UserRaisingList from "./components/UserRaisingList";
import Register from "./components/Register";
import LevantamientosStatistics from "./components/LevantamientosStatistics";
import LevantamientosStatisticsUser from "./components/LevantamientosStatisticsUser";
import ProjectsList from "./components/ProjectsList";
import ProjectsListAll from "./components/ProjectsListAll";
import ProjectEvalueList from "./components/ProjectEvalueList";
import DownloadList from "./components/DownloadList";
import DownloadEvaluationList from "./components/DownloadEvaluationList";
import Home from "./components/Home";
import Gallery from "./components/Gallery";
import UserGallery from "./components/UserGallery";
import ProjectExplorer from "./components/ProjectExplorer";
import Requestdel from "./components/Requestdel";

Vue.use(VueRouter);

const routes = [
  {
    path: "/inicio",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/reset_password",
    name: "reset_password",
    component: PasswordChange
  },
  {
    path: "/registro",
    name: "registro",
    component: Register
  },
  {
    path: "/privacy",
    name: "privacy",
    component: Privacy
  },
  {
    path: "/requestdel",
    name: "requestdel",
    component: Requestdel
  },
  {
    path: "/support",
    name: "support",
    component: Support
  },
  {
    path: "/compartir/:id",
    name: "compartir",
    component: CompartirMapa
  },

  {
    path: "/levantamientos/:id",
    name: "levantamientos",
    component: ExplorerMapUser,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/levProyecto/:id",
    name: "levantamientosPorProyecto",
    component: ExplorerProjectMapUser,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/",
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "",
        redirect: { name: "explorer" }
      },
      {
        path: "/explorer",
        name: "explorer",
        component: ExplorerMap, // mapa principal
        meta: {
          requiresAuth: true,
          // permission: "todos"
        }
      },
      {
        path: "/gallery",
        name: "gallery",
        component: Gallery,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/users",
        name: "users",
        component: UserGallery,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/explora",
        name: "ProjectExplorer",
        component: ProjectExplorer,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/userList",
        component: UserList,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/guestUserList",
        component: GuestUserList,
        name: "Invitaciones",
        meta: {
          requiresAuth: true,
          permission: "lider",
        }
      },
      {
        path: "/configuracion",
        component: Config,
        meta: {
          requiresAuth: true,
          permission: "admin",
        }
      },
      {
        path: "/raising",
        component: RaisingList,
        name: "viewRaisingEvaluation", // revision de aportes
        meta: {
          requiresAuth: true,
          permission: "revisor",
        }
      },
      {
        path: "/userRaising",
        component: UserRaisingList,
        name: "viewRaising", // mis aportes
        meta: {
          requiresAuth: true,
          // permission: "todos"
        }
      },
      {
        path: "/estadisticas",
        component: LevantamientosStatistics,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/estadisticasUser",
        component: LevantamientosStatisticsUser,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/proyectos",
        component: ProjectsList,
        name: "viewProject", // mis proyectos
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/proyectosTodos",
        component: ProjectsListAll,
        name: "viewProjectAll",
        meta: {
          requiresAuth: true,
          permission: "revisor"
        }
      },
      {
        path: "/projectEvaluation",
        component: ProjectEvalueList,
        name: "viewProjectEvaluation",
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/download",
        component: DownloadList,
        name: "viewDownload",
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
      {
        path: "/downloadEvaluation",
        component: DownloadEvaluationList,
        meta: {
          requiresAuth: true,
          permission: "admin"
        }
      },
    ]
  }
];

const router = new VueRouter({ 
  mode: "history", 
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // Verificar autenticación
  if (to.meta.requiresAuth && !localStorage.getItem("accessToken")) {
    next({ 
      name: "login", 
      query: { next: to.fullPath } 
    });
    return;
  }

  // Por tipo de usuario
  if (to.meta.requiresAuth) {
    const userCategory = window.atob(localStorage.getItem("category"));
    // const userCategory = localStorage.getItem("category");
    
    // "admin" pa nosotros
    if (to.meta.permission === "admin" && userCategory !== "ADMINISTRADOR") {
      next({ name: "explorer" });
      return;
    }
    
    // "lider" pa la banda
    if ((to.meta.permission === "lider" && userCategory !== "LIDER DE PROYECTO" && userCategory !== "ADMINISTRADOR")) {
      next({ name: "explorer" });
      return;
    }
    
    // "revisor" tambien pa la banda
    if (to.meta.permission === "revisor" && userCategory !== "REVISOR" && userCategory !== "LIDER DE PROYECTO" && userCategory !== "ADMINISTRADOR") {
      next({ name: "explorer" });
      return;
    }
  }

  // si todo bien sigue
  next();
});

export default router;
